// Selectable layouts for the public event-history article
// (EventHistoryArticle picker + PublicEventArticle renderer).
//
// `id` must match server/helpers/publicHistoryArticle.js's ARTICLE_TEMPLATES
// exactly — the id is what's persisted on t_event.public_history_template.
// The CSS for each lives in client/src/styles/articleTemplates.css under
// `.public-article--<id>`.

export const ARTICLE_TEMPLATES = [
  {
    id: 'classic-newspaper',
    label: 'Classic Newspaper',
    description: 'Serif masthead, drop cap, thin rules and small italic photo cutlines.',
  },
  {
    id: 'magazine-feature',
    label: 'Magazine Feature',
    description: 'Bold sans headline over a kicker line, cream page, accent rule.',
  },
  {
    id: 'bold-block',
    label: 'Bold Block',
    description: 'A bold color frame around the headline and each caption.',
  },
  {
    id: 'minimal-editorial',
    label: 'Minimal Editorial',
    description: 'A hero photo, generous whitespace, and a large centered headline.',
  },
  {
    id: 'two-column-quote',
    label: 'Two-Column Quote',
    description: 'Two-column serif body copy with captions styled as pulled quotes.',
  },
  {
    id: 'photo-essay',
    label: 'Photo Essay',
    description: 'Full-width photos that alternate side-to-side with their captions.',
  },
];

export const DEFAULT_ARTICLE_TEMPLATE = 'classic-newspaper';

export const ARTICLE_TEMPLATE_IDS = ARTICLE_TEMPLATES.map((t) => t.id);

export function getArticleTemplate(id) {
  return ARTICLE_TEMPLATES.find((t) => t.id === id) || ARTICLE_TEMPLATES[0];
}
